import { ScaleElement } from '@scale/base-element';

class ScaleTabs extends ScaleElement {
  setup() {
    const buttons = this.refs('tab-button');
    const panels = this.querySelectorAll('[role="tabpanel"]');
    if (!buttons.length || !panels.length) return;

    for (const btn of buttons) {
      this.on('click', (e) => this.#selectTab(e.currentTarget), { target: btn });
      this.on('keydown', (e) => this.#handleKeydown(e), { target: btn });
    }

    // Activate first tab
    if (!this.querySelector('[aria-selected="true"]')) {
      this.#selectTab(buttons[0]);
    }
  }

  #selectTab(button) {
    const buttons = this.refs('tab-button');
    const panels = this.querySelectorAll('[role="tabpanel"]');

    for (const btn of buttons) {
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('tabindex', '-1');
    }

    button.setAttribute('aria-selected', 'true');
    button.setAttribute('tabindex', '0');
    button.focus();

    const targetId = button.getAttribute('aria-controls');
    for (const panel of panels) {
      panel.setAttribute('aria-hidden', panel.id === targetId ? 'false' : 'true');
    }
  }

  #handleKeydown(e) {
    const buttons = this.refs('tab-button');
    const index = buttons.indexOf(e.currentTarget);
    let next;

    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        next = buttons[(index + 1) % buttons.length];
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        next = buttons[(index - 1 + buttons.length) % buttons.length];
        break;
      case 'Home':
        e.preventDefault();
        next = buttons[0];
        break;
      case 'End':
        e.preventDefault();
        next = buttons[buttons.length - 1];
        break;
      default:
        return;
    }

    if (next) this.#selectTab(next);
  }

  onBlockSelect(e) {
    const panels = this.querySelectorAll('[role="tabpanel"]');
    const buttons = this.refs('tab-button');

    for (let i = 0; i < panels.length; i++) {
      if (panels[i].querySelector(`[id="shopify-block-${e.detail.blockId}"]`) || panels[i].id?.includes(e.detail.blockId)) {
        this.#selectTab(buttons[i]);
        break;
      }
    }
  }
}

if (!customElements.get('scale-tabs')) {
  customElements.define('scale-tabs', ScaleTabs);
}
